import type { ReactNode } from 'react'
interface NumberImageProps {
  className?: any
  color: string
  circleColor?: string
  circleFillColor?: string
  numeral: number
  width?: string
  height?: string
  ariaHidden?: boolean
  ariaLabel?: string
}

// TODO: refactor to use CSS class instead of inline styles and props
export function NumberImage({
  className,
  color,
  circleColor = color,
  circleFillColor = 'transparent',
  numeral,
  ariaHidden = true,
  ariaLabel = '',
  width = '42',
  height = '42',
}: NumberImageProps): ReactNode {
  function getNumberIcon(n: number): ReactNode {
    if (n === 1) {
      return (
        <path
          d="M24.164 28V14.266H21.338C20.69 15.742 19.394 16.822 17.558 17.2V19.828C19.088 19.648 20.438 18.82 21.248 17.776V28H24.164Z"
          fill={color}
        />
      )
    }
    if (n === 2) {
      return (
        <path
          d="M25.872 28.0002V25.3902H20.31L22.11 23.7162C23.388 22.5282 25.296 20.5302 25.296 18.1362C25.296 15.5622 23.388 14.0142 20.76 14.0142C17.664 14.0142 15.936 15.7962 15.828 19.1622H18.456C18.546 17.2722 19.32 16.4622 20.724 16.4622C22.074 16.4622 22.65 17.2722 22.65 18.3882C22.65 19.4862 21.876 20.6202 20.274 22.0422L15.99 25.8762V28.0002H25.872Z"
          fill={color}
        />
      )
    }
    if (n === 3) {
      return (
        <path
          d="M21.03 28.27C24.054 28.27 26.088 26.47 26.088 23.86C26.088 22.24 25.242 20.728 23.244 20.494C24.558 20.206 25.26 19.108 25.26 17.794C25.26 15.634 23.478 13.996 20.85 13.996C18.258 13.996 16.422 15.67 16.278 18.262H18.888C19.086 16.966 19.806 16.462 20.796 16.462C21.93 16.462 22.488 17.074 22.488 18.01C22.488 19.018 21.714 19.648 20.616 19.648H19.878V21.952H20.724C22.362 21.952 23.172 22.6 23.172 23.824C23.172 25.03 22.47 25.822 21.084 25.822C19.572 25.822 18.816 25.03 18.654 23.608H15.756C15.9 26.488 17.988 28.27 21.03 28.27Z"
          fill={color}
        />
      )
    }
    if (n === 4) {
      return (
        <path
          d="M26.324 28V24.976H27.98V22.366H26.324V14.266H23.516L17.648 22.186V24.976H23.426V28H26.324ZM23.426 17.92V22.366H20.312L23.426 17.92Z"
          fill={color}
        />
      )
    }
  }

  return (
    <svg
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21" r="20" stroke={circleColor} fill={circleFillColor} strokeWidth="2" />

      {getNumberIcon(numeral)}
    </svg>
  )
}
